module.exports = __webpack_public_path__ + "static/media/bg_gamefication_companies.d0436302.png";